import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUtils';
import './styles.css';

const Login: React.FC = () => {
  const navigate = useNavigate();

  const handleLogin = (provider: string) => {
    console.log(`Logging in with ${provider}`);
    // 实际项目中这里会有真正的登录逻辑
    // 登录成功后跳转到首页
    navigate('/home');
  };

  return (
    <div className="login-container">
      <div className="login-content">
        <div className="avatar-container">
          <img 
            src={getImageUrl("./img/eva.png", "avatar")} 
            alt="AIeva" 
            className="login-avatar" 
          />
        </div>
        
        <div className="login-title">
          <span className="login-text">Log in</span> to Aleva
        </div>
        
        <p className="login-description">
          Welcome back! Sign in using your social account or email to continue us
        </p>
        
        <div className="social-login-options">
          <button 
            className="social-login-button facebook" 
            onClick={() => handleLogin('facebook')}
          >
            <img src={getImageUrl("./img/facebook.svg", "social")} alt="Facebook" />
          </button>
          
          <button 
            className="social-login-button google" 
            onClick={() => handleLogin('google')}
          >
            <img src={getImageUrl("./img/google.svg", "social")} alt="Google" />
          </button>
          
          <button 
            className="social-login-button apple" 
            onClick={() => handleLogin('apple')}
          >
            <img src={getImageUrl("./img/apple.svg", "social")} alt="Apple" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;